import React from 'react';
import { useShowContext } from 'ui-builder';
import { AbstractTask, TaskType } from 'nekst-api';
import Layout from './Layout';

export function EventField() {
  const context = useShowContext<AbstractTask>();

  if (context?.data.type === TaskType.EVENT) {
    return (
      <Layout />
    );
  } else {
    return null;
  }
}
